const project = window.fe.project === 'purchaser' ? 'purchaser/mall' : window.fe.project
export default {
  // 打开聊天窗口
  openConnected: {
    url: `${project}/mallQuestionSearch/connected`,
    type: 'get'
  },
  // 搜索问题
  searchQuestion: {
    url: `${project}/mallQuestionSearch/searchByKeywords`,
    type: 'post'
  }
}
